import React from "react";
import {Redirect, Route} from "react-router-dom";

import {isLoggedIn} from "../../services/loginService";
import {Routes} from "../../utils/constants";


// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute: React.FC<any> = ({children, ...rest}) => {
    return (
        <Route
            {...rest}
            render={({location}) =>
                isLoggedIn() ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: Routes.Login,
                            state: {from: location.pathname}
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
